/**
 * Paleta FIXA das 6 categorias 6M (Ishikawa) — o MESMO tom em todos os
 * blocos (fishbone, Pareto, tendência, custo e pills), em qualquer tela.
 * Tokens --chart-* funcionam idênticos nos temas claro e escuro.
 *
 * Regra do brief: cor comunica CATEGORIA aqui (peso/estado), nunca
 * decoração — não reusar esses tons para outra semântica.
 */
import { CATEGORIAS_6M } from "../../services/producaoV2";

export const COR_CATEGORIA = {
  MAQUINA: "var(--chart-1)", // violeta
  MAO_DE_OBRA: "var(--chart-3)", // azul-céu
  MATERIAL: "var(--chart-5)", // rosa
  METODO: "var(--chart-2)", // esmeralda
  MEDICAO: "var(--chart-4)", // âmbar
  MEIO_EXTERNO: "var(--chart-7)", // teal
};

/** {codigo: label} das 6 categorias (derivado do catálogo do service). */
export const LABEL_CATEGORIA = CATEGORIAS_6M.reduce((acc, c) => {
  acc[c.codigo] = c.label;
  return acc;
}, {});

/** Ordem canônica das 6 categorias (mesma do backend/fishbone). */
export const ORDEM_CATEGORIAS = CATEGORIAS_6M.map((c) => c.codigo);
